'use client';

import { TranslationSnapshotProvider } from '@eliadmin/core/src/i18n/translation-context';
import type { PropsWithChildren } from 'react';
import { GENERATED_TRANSLATIONS } from '../dictionaries/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3';

export default function GeneratedLocaleTranslationBoundary({ children }: PropsWithChildren) {
  return (
    <TranslationSnapshotProvider translations={GENERATED_TRANSLATIONS}>
      {children}
    </TranslationSnapshotProvider>
  );
}
